/**
 * ARAM Platform - Root Layout
 * Core Desarrollos S.A.S - Copyright 2024-2025
 */

import { Outlet } from 'react-router-dom'
import { useEffect } from 'react'
import { useThemeStore } from '@/stores/themeStore'

export function RootLayout() {
  const { theme } = useThemeStore()

  useEffect(() => {
    const root = window.document.documentElement
    root.classList.remove('light', 'dark')
    root.classList.add(theme)
  }, [theme])

  return <Outlet />
}
